import { handlize } from "../lib/util.functions";

class ProductForm extends HTMLElement {
  #abortController
  connectedProductForm
  #matchQuantity
  #isConnectedProduct
  #productId 
  /* #productTitle */

  constructor() {
    super();
    console.log('ProductForm constructor');
  }

  connectedCallback() {
    console.log('ProductForm connectedCallback');
    if (!this.#abortController) this.#abortController = new AbortController();
    const { signal } = this.#abortController;
    this.form = this.querySelector('form[data-product-form]');
    /* this.customTextInput = this.form?.querySelector('custom-text-input'); */
    this.customTextRadioGroups = Array.from(this.form?.querySelectorAll('custom-text-radio-group')) || [];
    const btn = this.form?.querySelector('[type="button"]');
    //
    if (this.form) {
      this.form.addEventListener('change', () => this.#onFormChange(), { signal });
      this.form.querySelectorAll('multiple-updater number-button input').forEach(el => el.addEventListener('input', () => this.#onFormChange(), { signal }));
      this.optionNames = Array.from(this.form.querySelectorAll('[data-option-name]')).map(el => el.dataset.optionName).filter(n => n.length);
      if (this.optionNames.length > 1) {
        this.lastInputs = Array.from(this.form.querySelectorAll(`.bundler-option-card input[name="${handlize(this.optionNames[this.optionNames.length - 1])}"`));
      }
      this.textInput1 = this.form.querySelector('input[name="custom_text_1"]');
      if (this.textInput1) {
        this.textInput1.addEventListener('input', () => this.#onFormChange(), { signal });
      }
      setTimeout(() => {
        this.#onFormChange();
      }, 100);
    }
    //
    if (btn) btn.addEventListener('click', (e) => this.#dispatchCustomEvent(e.target.name), { signal });
  }

  disconnectedCallback() {
    this.#abortController?.abort();
    this.#abortController = null;
  }

  static get observedAttributes() {
    return ['data-match-quantity', 'data-connected-product', 'data-product-id', /* 'data-product-title' */];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-match-quantity') {
      this.#matchQuantity = parseInt(newValue);
      this.#onFormChange();
    }
    //
    if (name === 'data-connected-product') {
      this.#isConnectedProduct = newValue == 'true';
    }
    //
    if (name === 'data-product-id') {
      this.#productId = newValue;
    }
    //
    /* if (name === 'data-product-title') {
      this.#productTitle = newValue;
    } */
  }

  getFormObject() {
    const data = new FormData(this.form);
    const obj = Object.fromEntries(data.entries());
    const numLines = this.customTextInput && obj[`custom_text_1`] ? this.customTextInput.dataset.numLines : 0;
    return { 
      ...obj, 
      numLines, 
      multiple: this.form.dataset.selectMultiple === 'true', 
      connected: this.#isConnectedProduct,
      productId: this.#productId,
      minQuantity: this.form.dataset.minQuantity ? parseInt(this.form.dataset.minQuantity) : 0, 
      /* productTitle: this.#productTitle */
    };
  }

  #onFormChange() {
    this.#dispatchCustomEvent('change');
    //
    const value = this.getFormObject();
    
    const optionsSelected = handlize(this.optionNames.map(str => value[handlize(str)]).join('-'));
    const firstOptionsSelected = handlize(this.optionNames.slice(0, -1).map(str => value[handlize(str)]).join('-'));
    /* console.log(this.optionNames, value, optionsSelected, firstOptionsSelected); */
    const variantImage = value[`${optionsSelected}-image`];
    //
    if (this.optionNames.length > 1 && this.lastInputs && this.lastInputs.length) {
      let v;
      const keysArr = Object.keys(value);
      //
      this.lastInputs.forEach(input => {
        v = handlize(input.value);
        /* console.log(firstOptionsSelected, v); */
        //
        if (keysArr.find(key => key.startsWith(firstOptionsSelected) && key.split(firstOptionsSelected)[1] === `-${v}`)) {
          input.disabled = false;
        } else {
          input.disabled = true;
          if (input.checked) input.checked = false;
        }
      })
    }
    //
    if (variantImage) {
      this.form.querySelector('input[name="image"]').value = variantImage;
      this.parentElement.parentElement.querySelector('img').src = variantImage;
    }
    //
    let valid = this.form.checkValidity(); /* console.log('first valid', valid); */
    let totalPrice = 0;
    let quantity = 0;
    let mp;
    //
    if (this.form.dataset.selectMultiple === 'true') {
      mp = this.#getMultiplePrice(value);
      /* console.log(mp); */
      quantity = mp.totalQuantity
    } else {
      quantity = (parseInt(value.quantity) || 1); 
    }
    //
    if (value.minQuantity > 0) {
      valid = quantity >= value.minQuantity;
    }
    //
    if (this.#matchQuantity) {
      if (!this.connectedProductTitle) this.connectedProductTitle = this.parentElement.querySelector('[data-connected-product-title]');
      this.connectedProductTitle.dataset.numSelected = quantity;
    }
    //
    if (valid) {
      /* set variantId input based on options selected */
      const variantId = value[optionsSelected];
      let variantPrice = this.form.dataset.included == 'true' ? 0 : parseInt(value[`${optionsSelected}-price`]);
      let afterFirstDiscount = this.form.dataset.included == 'true' ? undefined : value[`after-first-discount`];
      //
      if (value[`${optionsSelected}-after-first-discount`]) {
        afterFirstDiscount = value[`${optionsSelected}-after-first-discount`];
      }
      //
      if (this.form.dataset.selectMultiple === 'true') {
        totalPrice = mp.totalPrice;
      } else {
        totalPrice = afterFirstDiscount ? variantPrice + ((quantity - 1) * parseInt(afterFirstDiscount)) : quantity * variantPrice;
      }
      //
      if (this.#matchQuantity) {
        valid = this.#matchQuantity === quantity;
      }
      //
      if (this.connectedProductForm) {
        this.connectedProductForm.dataset.matchQuantity = quantity;
        this.connectedProductForm.previousElementSibling.dataset.matchQuantity = quantity;
        this.connectedProductForm.querySelectorAll('[data-num-allowed]').forEach(el => el.dataset.numAllowed = quantity);
      }
      //
      if (variantId) {
        this.form.querySelector('input[name="variantId"]').value = variantId;
        const ctrg = this.customTextRadioGroups.find(el => el.dataset.id === variantId)
          || this.customTextRadioGroups.find(el => el.dataset.id === this.#productId);
        //
        if (ctrg) {
          if (this.customTextInput !== ctrg.customTextInput) {
            /* console.log('custom inputs dont equal', this.customTextInput, ctrg.customTextInput); */
            this.customTextInput = ctrg.customTextInput;
            if (this.customTextRadioGroups.length > 1) {
              this.customTextRadioGroups.forEach(el => el.dataset.disabled = true);
              ctrg.dataset.disabled = false;
              setTimeout(() => {
                this.#onFormChange();
              }, 0);
            }
          }
        }
      }
      if (variantPrice) this.form.querySelector('input[name="price"]').value = variantPrice;
      if (afterFirstDiscount) this.form.querySelector('input[name="use-after-first-discount"]').value = afterFirstDiscount;
      this.#dispatchCustomEvent('update', { formData: {...this.getFormObject(), totalPrice }, valid});
    } else {
      this.#dispatchCustomEvent('update', { formData: {...value, totalPrice }, valid });
    }
  }

  #getMultiplePrice(obj) {
    const data = new FormData(this.form);
    const entries = data.entries();
    let totalPrice = 0, totalQuantity = 0, variantKey, price, options, quantity;
    //
    for (const [key, value] of entries) {
      if (key.startsWith('multiple-') && this.form.querySelector(`label:has(input:checked) + multiple-updater:has(input[name="${key}"])`)) {
        if (this.form.dataset.included == 'true') {
          price = 0;
        } else {
          options = obj['option-names'];
          options.split(',').forEach((name, i, arr) => {
            if (i === 0) options = options.concat('|');
            //
            if (i < arr.length - 1) {
              options = options.concat(obj[name]);
              options = options.concat(',');
            } else {
              options = options.concat(key.split('multiple-')[1]);
            }
          });
          //
          variantKey = handlize(options.split('|')[1]);
          price = parseInt(obj[`${variantKey}-price`]);
        }
        quantity = parseInt(value);
        //
        if (quantity) {
          totalPrice += (quantity * price);
          totalQuantity += quantity
        }
      }
    }
    return {totalPrice, totalQuantity};
  }

  #dispatchCustomEvent(name, otherData = {}) {
    const event = new CustomEvent('formevent', {
      detail: {
        name,
        ...otherData
      },
    });
    this.dispatchEvent(event);
  }
}

customElements.define('product-form', ProductForm);